var styles = {
raw: ".hcr-mark-12-2-0{background-color:var(--hcr-highlight-color);color:var(--hcr-content-primary-color)}",
map:{"hcr-mark":"hcr-mark-12-2-0"}};

export { styles as default };
